import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { SavedSearchForm } from 'components/saved_search/form';
import { saveSavedSearch } from '../store/actions/saved_searches';
export class SavedSearchPopover extends React.Component {
  static propTypes = {
    onSave: PropTypes.func.isRequired,
  };


  handleSave = (name) => {
    const { onSave } = this.props;
    onSave(name);
    this.handleCancel();
  }

  //This is being done as a hack to close the popover being created
  handleCancel = () => document.body.click();

  render() {
    return (
      <SavedSearchForm
        onCancel={this.handleCancel}
        onSave={this.handleSave}
      />
    );
  }
}

const mapDispatchToProps = {
  onSave: saveSavedSearch
};

export default connect(() => ({}), mapDispatchToProps)(SavedSearchPopover);
